<div class="container">

  <div class="logo hidden"><img src="../../../../assets/images/logo_header.svg" /></div>
  <div class="title">
    <div style="height: 2rem;">{{getTitle()[1]}}</div>
    <div style="position:relative">
      {{getTitle()[2]}}
      <ng-container *ngIf="compilation.editCount && !['IN', 'PFIN', 'CN', 'PFCN'].includes(typeData.get(compilation.type).code)"> - {{compilation.editCount | nrkPad : 2}}</ng-container>
      <div style="position:absolute;right:0;top:0;display:table-cell;text-align:right;font-weight:normal">
        <div>
          <span class="textbox" style="font-size:10pt">Issue Date: {{compilation.issueDate | date : 'yyyy-MM-dd'}}</span>
        </div>
        <!-- <div *ngIf="data.visibleMap.dueDate">
          <span class="textbox">Due date: {{compilation.dueDate | date : 'yyyy-MM-dd'}}</span>
        </div> -->
      </div>
    </div>
    <ng-container *ngIf="data.getObicString(compilation, tree)">
      <div class="mt-1" style="font-size:smaller">{{data.getObicString(compilation, tree)}}</div>
    </ng-container>
  </div>
  <!-- <div class="top-date" style="bottom:2.5em">
    <span class="textbox">Issue date: {{compilation.issueDate | date : 'yyyy-MM-dd'}}</span>
  </div>
  <div *ngIf="data.visibleMap.dueDate" class="top-date" style="bottom:1em">
    <span class="textbox">Due date: {{compilation.dueDate | date : 'yyyy-MM-dd'}}</span>
  </div> -->

  <div class="top-segment">

    <!-- <div style="position:relative;bottom:0;height:17mm;padding-bottom:1mm">
      <div style="position:absolute;bottom:0">
        <div *ngIf="compilation.documentStatus == 3">
          Cancel Reason: {{compilation.cancelReason}}
        </div>
        <div *ngIf="compilation.documentStatus == 4">
          Revision Reason: {{compilation.cancelReason}}
        </div>
        <div *ngIf="compilation.sampleRequest">
          Sample Request
        </div>
        <div *ngIf="compilation.creditNoteReason">
          <ng-container *ngIf="tree?.linkedIN?.code">Credited Invoice: {{tree.linkedIN.code}}</ng-container>
          &nbsp; {{tree?.linkedIN?.code ? 'Reason' : 'Credit Note Reason'}}: {{compilation.creditNoteReason}}
        </div>
      </div>
    </div> -->

    <!-- ============================================ document status / recipient ... ============================================================================= -->
<!--    <table class="address">
      <tr>
        <td>
          <div *ngIf="!['DN'].includes(typeData.get(compilation.type).code) || compilation.invoiceType !== 'delivery'" class="textbox recipient">{{compilation.recipientAddress}}</div>
          <div *ngIf="['DN'].includes(typeData.get(compilation.type).code) && compilation.invoiceType === 'delivery'" class="textbox recipient">
            <p style="padding:0 0 0.5rem;margin:0">Delivery Address</p>{{compilation.deliveryAddress}}
          </div>
        </td>
        <td>
          <div class="textbox issuer">{{compilation.issuerAddress}}</div>
          <!~~ <div class="textbox">{{compilation.pfspoInDisclaimer}}</div> ~~>
        </td>
      </tr>
      <tr>
        <td *ngIf="compilation.paymentPlan?.recipientUID?.length">
          <div><b>Recipient UID / CRN:</b></div>
          <div class="textbox">{{compilation.paymentPlan.recipientUID}}</div>
        </td>
        <td></td>
      </tr>
      <tr *ngIf="compilation.visibleFields.includes('invoiceSendTo') && !isEmpty(compilation.invoiceSendTo)"><td class="pt-3">
        <div><b>Send Invoice to:</b></div>
        <div class="textbox">{{compilation.invoiceSendTo}}</div>
      </td><td></td></tr>

      <ng-container *ngIf="!['DN'].includes(typeData.get(compilation.type).code) || compilation.invoiceType !== 'delivery'">
        <tr *ngIf="compilation.recipientContact || compilation.issuerContact">
          <td *ngIf="compilation.recipientContact" class="pt-3 contact"><b>Contact:</b></td>
          <td *ngIf="!compilation.recipientContact"></td>
          <td *ngIf="compilation.issuerContact" class="pt-3 contact"><b>Contact:</b></td>
          <td *ngIf="!compilation.issuerContact"></td>
        </tr>
        <tr *ngIf="compilation.recipientContact || compilation.issuerContact">
          <td class="contact">
            <div class="textbox">{{compilation.recipientContact}}</div>
          </td>
          <td class="contact">
            <div class="textbox">{{compilation.issuerContact}}</div>
          </td>
        </tr>
      </ng-container>

      <ng-container *ngIf="['DN'].includes(typeData.get(compilation.type).code) && compilation.invoiceType === 'delivery'">
        <tr *ngIf="compilation.deliveryContact || compilation.issuerContact">
          <td *ngIf="compilation.deliveryContact" class="pt-3 contact"><b>Contact:</b></td>
          <td *ngIf="!compilation.deliveryContact"></td>
          <td *ngIf="compilation.issuerContact" class="pt-3 contact"><b>Contact:</b></td>
          <td *ngIf="!compilation.issuerContact"></td>
        </tr>
        <tr *ngIf="compilation.deliveryContact || compilation.issuerContact">
          <td class="contact">
            <div class="textbox">{{compilation.deliveryContact}}</div>
          </td>
          <td class="contact">
            <div class="textbox">{{compilation.issuerContact}}</div>
          </td>
        </tr>
      </ng-container>

      <tr *ngIf="compilation.receptionHours && ['DN'].includes(typeData.get(compilation.type).code)"><td>Reception Hours: {{compilation.receptionHours}}</td><td></td></tr>
    </table>
-->
    <div style="display:table; width:100%; padding-bottom:0.5rem;">

      <div style="display:table-cell;text-align:right;padding-bottom:3mm;">
        <div *ngIf="compilation.documentStatus == 3">
          Cancel Reason: {{compilation.cancelReason}}
        </div>
        <div *ngIf="compilation.documentStatus == 4">
          Revision Reason: {{compilation.cancelReason}}
        </div>
        <div *ngIf="compilation.sampleRequest">
          Sample Request
        </div>
        <div *ngIf="compilation.creditNoteReason">
          <ng-container *ngIf="tree?.linkedIN?.code">Credited Invoice: {{tree.linkedIN.code}}</ng-container>
          &nbsp; {{tree?.linkedIN?.code ? 'Reason' : 'Credit Note Reason'}}: {{compilation.creditNoteReason}}
        </div>  
      </div>

      <!-- <div style="display:table-cell;text-align:right;">
        <div>
          <span class="textbox">Issue date: {{compilation.issueDate | date : 'yyyy-MM-dd'}}</span>
        </div>
        <div *ngIf="data.visibleMap.dueDate">
          <span class="textbox">Due date: {{compilation.dueDate | date : 'yyyy-MM-dd'}}</span>
        </div>
      </div> -->

    </div>

    <div class="address">
      <div class="address-column-left">
        <div class="address-upper">

          <div *ngIf="!['DN'].includes(typeData.get(compilation.type).code) || compilation.invoiceType !== 'delivery'" class="textbox recipient">{{compilation.recipientAddress}}</div>
          <div *ngIf="['DN'].includes(typeData.get(compilation.type).code) && compilation.invoiceType === 'delivery'" class="textbox recipient">
            <p style="padding:0 0 0.5rem;margin:0">Delivery Address</p>{{compilation.deliveryAddress}}
          </div>
          <div *ngIf="compilation.paymentPlan.recipientUID">
            <!-- <div><b>Recipient UID / CRN:</b></div> -->
            <br>
            <div class="textbox">{{compilation.paymentPlan.recipientUID}}</div>
            <br>
          </div>
          <ng-container *ngIf="compilation.visibleFields.includes('invoiceSendTo') && !isEmpty(compilation.invoiceSendTo)">
            <div><b>Send Invoice to:</b></div>
            <div class="textbox">{{compilation.invoiceSendTo}}</div>
            <br>
          </ng-container>
          <!-- <div *ngIf="compilation.recipientContact || compilation.deliveryContact">
            <br>
            <div class="contact"><b>Contact:</b></div>
            <div class="textbox" *ngIf="['DN'].includes(typeData.get(compilation.type).code) && compilation.invoiceType === 'delivery'; else recCt">{{compilation.deliveryContact}}</div>
            <ng-template #recCt><div class="textbox">{{compilation.recipientContact}}</div></ng-template>
          </div> -->

        </div>
        <div class="address-lower">

          <!-- <div *ngIf="compilation.paymentPlan.recipientUID">
            <div><b>Recipient UID / CRN:</b></div>
            <div class="textbox">{{compilation.paymentPlan.recipientUID}}</div>
          </div> -->
          <div *ngIf="compilation.recipientContact || compilation.deliveryContact">
            <div class="contact"><b>Contact:</b></div>
            <div *ngIf="['DN'].includes(typeData.get(compilation.type).code) && compilation.invoiceType === 'delivery'; else recCt" class="textbox">{{compilation.deliveryContact}}</div>
            <ng-template #recCt><div class="textbox">{{compilation.recipientContact}}</div></ng-template>
          </div>
          
        </div>
      </div>
      <div class="address-column-right">
        <div class="address-upper">

          <div class="textbox issuer">{{compilation.issuerAddress}}</div>

        </div>
        <div class="address-lower">
          
          <div *ngIf="compilation.issuerContact">
            <div class="contact"><b>Contact:</b></div>
            <div class="textbox">{{compilation.issuerContact}}</div>
          </div>

          <div *ngIf="compilation.type === typeData.get('OF').id" style="font-size:0.88rem">
            {{'purchase_order_nrka@nipponrika.eu'}}
          </div>
          <div *ngIf="compilation.type === typeData.get('IN').id" style="font-size:0.88rem">
            {{'invoices_nrka@nipponrika.eu'}}
          </div>

      </div>
      </div>
    </div>

    <hr class="separator" />

  </div>

  <div *ngIf="['DN'].includes(typeData.get(this.compilation.type).code) && (compilation.receptionHours || tree?.linkedOC?.receptionHours)">
    <div class="section-header">Reception Hours</div>
    <span class="textbox">{{compilation.receptionHours || tree?.linkedOC?.receptionHours}}</span>
  </div>

  <div *ngIf="['DN'].includes(typeData.get(this.compilation.type).code) && (compilation.holidays?.length || tree?.linkedOC?.holidays?.length)">
    <div class="section-header">Company Holidays</div>
    <span class="textbox">{{(compilation.holidays[0] || tree?.linkedOC?.holidays[0]) | date : 'yyyy-MM-dd'}}</span> - <span class="textbox">{{(compilation.holidays[1] || tree?.linkedOC?.holidays[1]) | date : 'yyyy-MM-dd'}}</span>
  </div>

  <div class="info-segment-new">
    <ul>

      <li>
        <div class="section-header">Customer Reference</div>
        <table class="gap-top">
          <tr *ngIf="compilation.customerName">
            <td><span class="label">Name:</span></td>
            <td><span>{{getCustomerReferenceName()}}</span></td>
          </tr>
          <tr *ngIf="compilation.customerDocumentNumber">
            <td><span class="label">PO&nbsp;Number:</span></td>
            <td><span>{{compilation.customerDocumentNumber}}</span></td>
          </tr>
          <tr *ngIf="compilation.customerDocumentDate">
            <td><span class="label">PO&nbsp;Date:</span></td>
            <td><span>{{compilation.customerDocumentDate | date : 'yyyy-MM-dd'}}</span></td>
          </tr>
          <tr *ngIf="compilation.awbBlNr">
            <td><span class="label">AWB&nbsp;/&nbsp;BL&nbsp;NO:</span></td>
            <td><span>{{compilation.awbBlNr}}</span></td>
          </tr>
          <tr *ngIf="compilation.contNr">
            <td><span class="label">CONT&nbsp;NO:</span></td>
            <td><span>{{compilation.contNr}}</span></td>
          </tr>
          <tr *ngIf="compilation.rfqReference">
            <td><span class="label">RFQ Ref:</span></td>
            <td><span>{{compilation.rfqReference}}</span></td>
          </tr>
          <tr *ngIf="compilation.rfqDate">
            <td><span class="label">RFQ Date:</span></td>
            <td><span>{{compilation.rfqDate | date : 'yyyy-MM-dd'}}</span></td>
          </tr>
          <tr *ngIf="tree?.linkedFC?.customerDocumentNumber">
            <td><span class="label">Frame&nbsp;Contract:</span></td>
            <td><span>{{tree?.linkedFC?.customerDocumentNumber}}</span></td>
          </tr>
          <tr *ngIf="tree?.linkedFC?.customerDocumentDate">
            <td><span class="label">FC&nbsp;Date:</span></td>
            <td><span>{{tree?.linkedFC?.customerDocumentDate | date : 'yyyy-MM-dd'}}</span></td>
          </tr>
        </table>
      </li>

      <!-- <li>
        <div class="section-header">Document Reference</div>
        <table>
          <tr *ngIf="compilation.code">
            <td><span class="label">Doc&nbsp;No:</span></td>
            <td><span>{{getTitle(true)}}</span></td>
          </tr>
          <tr *ngIf="compilation.editCount && !['IN', 'PFIN'].includes(typeData.get(compilation.type).code)">
            <td><span class="label">Edit:</span></td>
            <td><span>{{(compilation.editCount < 10 ? '0' : '') + compilation.editCount}}</span></td>
          </tr>
          <tr *ngIf="compilation.issueDate">
            <td style="padding-right:1rem"><span class="label">Issue&nbsp;Date:</span></td>
            <td><span>{{compilation.issueDate | date : 'yyyy-MM-dd'}}</span></td>
          </tr>
        </table>
      </li> -->

      <!-- <li *ngIf="compilation.internal || tree?.linkedFC?.code || tree?.linkedOR?.code || compilation.supplierReference || compilation.transportRun?.relatedCS">
        <div *ngIf="compilation.internal || tree?.linkedFC?.code || tree?.linkedOR?.code || compilation.supplierReference" class="section-header">Nippon Rika Reference</div>
        <table>
          <ng-container *ngIf="compilation.internal || tree?.linkedFC?.code || tree?.linkedOR?.code || compilation.supplierReference">
            <tr *ngIf="compilation.supplierReference">
              <td><span class="label">Quotation&nbsp;Ref:</span></td>
              <td><span>{{compilation.supplierReference}}</span></td>
            </tr>
            <tr *ngIf="compilation.internal || tree?.linkedOR?.code">
              <td><span class="label">Internal:</span></td>
              <td><span>{{compilation.internal || tree?.linkedOR?.code}}</span></td>
            </tr>
            <tr *ngIf="tree?.linkedFC?.code">
              <td><span class="label">Frame&nbsp;Contract&nbsp;Ref:</span></td>
              <td><span>{{tree?.linkedFC?.code}}</span></td>
            </tr>
          </ng-container>
          <ng-container *ngIf="compilation.transportRun?.relatedCS">
            <tr><td class="section-header" style="padding-top:2mm">Shipment Reference</td></tr>
            <tr *ngIf="compilation.transportRun?.relatedCS?.length">
              <td><span class="label">Related CS:</span></td>
              <td>
                <span>{{ compilation.transportRun?.relatedCS }}</span>
              </td>
            </tr>
          </ng-container>

        </table>
      </li> -->

      <li><ng-container *ngIf="tree?.linkedOF?.nameOverride || tree?.linkedOF?.code || tree?.linkedPfspos?.length || tree?.linkedCSsCodes || tree.linkedPfspoCodes">
        <div class="section-header">Nippon Rika Reference</div>
        <table class="gap-top">
          <tr *ngIf="tree?.linkedOF?.nameOverride || tree?.linkedOF?.code">
            <td><span class="label">Quotation&nbsp;Ref:</span></td>
            <td><span>{{tree?.linkedOF?.nameOverride || tree?.linkedOF?.code}}</span></td>
          </tr>
          <tr *ngIf="tree?.linkedCsSpoCodes?.length">
            <td><span class="label">Docs:</span></td>
            <td class="textbox">{{tree?.linkedCsSpoCodes.join('\n')}}</td>
          </tr>
        </table>
      </ng-container></li>

      <li><ng-container *ngIf="compilation.manufacturerRecipient || compilation.manufacturerRecipient || compilation.internal || compilation.machineSN">
        <div class="section-header">Manufacturer Reference</div>
        <table class="gap-top">
          <tr *ngIf="compilation.manufacturerRecipient">
            <td><span class="label">Company:</span></td>
            <td><span>{{data.getBusinessName(compilation.manufacturerRecipient)}}</span></td>
          </tr>
          <tr *ngIf="compilation.internal">
            <td><span class="label">Project Number:</span></td>
            <td><span>{{compilation.internal}}</span></td>
          </tr>
          <tr *ngIf="compilation.machineSN">
            <td><span class="label">Machine S/N:</span></td>
            <td><span class="textbox">{{compilation.machineSN}}</span></td>
          </tr>
        </table>
      </ng-container></li>

          <!-- <ng-container *ngIf="compilation.internal || compilation.machineSN">
            <tr><td colspan="2"><div class="section-header">Manufacturer Reference</div></td></tr>
            <tr *ngIf="compilation.internal">
              <td><span class="label">Project #:</span></td>
              <td><span>{{compilation.internal}}</span></td>
            </tr>
            <tr *ngIf="compilation.machineSN">
              <td><span class="label">Machine S/N:</span></td>
              <td><span>{{compilation.machineSN}}</span></td>
            </tr>
          </ng-container>
 -->

    </ul>

    <ul>
      <!-- delivery / pick up  / service -->
      <li>
        <ng-container *ngIf="!isEmpty(compilation.deliveryAddress, true) && (!compilation.invoiceType || compilation.invoiceType == 'delivery')">
          <div class="section-header">Delivery Address</div>
          <div class="textbox">{{compilation.deliveryAddress}}</div>
          <!-- <div class="textbox" *ngIf="compilation.deliveryContact"><i>Contact:</i><br>{{compilation.deliveryContact}}</div> -->
        </ng-container>

        <ng-container *ngIf="!isEmpty(compilation.pickUpAddress, true) && (!compilation.invoiceType || compilation.invoiceType == 'pickup')">
          <div class="section-header">Pick-up Address</div>
          <div class="textbox">{{compilation.pickUpAddress}}</div>
          <div class="textbox" *ngIf="compilation.pickUpContact"><i>Contact:</i><br>{{compilation.pickUpContact}}</div>
        </ng-container>

        <ng-container *ngIf="!isEmpty(compilation.serviceProvided, true) && (!compilation.invoiceType || compilation.invoiceType == 'service')">
          <div class="section-header">Service Provided</div>
          <div class="textbox">{{compilation.serviceProvided}}</div>
        </ng-container>
      </li>

      <!-- place of loading -->
      <li>
        <ng-container *ngIf="data.visibleMap.placeOfLoading && !isEmpty(compilation.placeOfLoading, true) && (!compilation.invoiceType || compilation.invoiceType != 'service')">
          <!-- <div class="section-header">{{['SPO', 'SPC', 'PFSPO', 'OC', 'DN','PL'].includes(typeData.get(compilation.type).code) && compilation.invoiceType === 'pickup' ? 'Place of delivery' : 'Place of loading'}}</div> -->
          <div class="section-header">{{compilation.invoiceType === 'pickup' ? 'Place of Delivery' : 'Place of Loading'}}</div>
          <div class="textbox">{{compilation.placeOfLoading}}</div>
          <div class="textbox" *ngIf="compilation.placeOfLoadingContact"><i>Contact:</i><br>{{compilation.placeOfLoadingContact}}</div>
        </ng-container>
      </li>

      <!-- manufacturer -->
      <!-- <li *ngIf="!isEmpty(compilation.manufacturerServiceproviderAddress)">
        <div class="section-header">{{compilation.invoiceType === 'service' ? 'Serviceprovider' : 'Manufacturer'}}</div>
        <div class="textbox">{{compilation.manufacturerServiceproviderAddress}}</div>
        <div class="textbox" *ngIf="compilation.manufacturerContact"><i>Contact:</i><br>{{compilation.manufacturerContact}}</div>
      </li> -->
      <li>
        <div *ngIf="!isEmpty(compilation.manufacturerServiceproviderAddress, true)">
          <div class="section-header">{{compilation.invoiceType === 'service' ? 'Serviceprovider Address' : 'Manufacturer Address'}}</div>
          <div class="textbox">{{compilation.manufacturerServiceproviderAddress}}</div>
          <div class="textbox" *ngIf="compilation.manufacturerContact"><i>Contact:</i><br>{{compilation.manufacturerContact}}</div>
        </div>
      </li>

<!--      <!~~ customer invoice ~~>
      <li>
        <ng-container *ngIf="data.getCustomerInvoiceAddress(compilation.customerReference)">
          <div class="section-header">Customer Invoice</div>
          <div class="textbox">{{data.getCustomerInvoiceAddress(compilation.customerReference)}}</div>
        </ng-container>
      </li>
-->
      <!-- <li *ngIf="['DN'].includes(typeData.get(compilation.type).code)"></li> -->

    </ul>

    <ul *ngIf="docFormAdditional.invoiceAddress && this.data.visibleMap.invoiceAddress && docFormAdditional.isPrint(docFormAdditional.getSection('invoiceAddress'))">
      <li>
        <b>Invoice Address</b>
        <div>{{docFormAdditional.invoiceAddress}}</div>
      </li>
    </ul>

    <ul *ngIf="compilation.pricingDisclaimer && this.data.visibleMap.pricingDisclaimer" style="margin-top:1rem">
      <li>
        <b>Disclaimer</b>
        <div>Please note the delivery date specified in the order does not fall within the period stipulated by a quantity contract, price agreement or similar. We reserve the right to adjust the prices, quantities and lead time of the goods accordingly.</div>
      </li>
    </ul>

  </div>

<!--  <table class="info-segment">
    <tr>
      <td>

        <!~~ =================================================== dates ... ====================================================================== ~~>
        <table class="left-info">
          <tr *ngIf="compilation.issueDate || compilation.code || compilation.internal"><!~~ todo: should always be true ~~>
            <td colspan="2">
              <div class="section-header">Nippon Rika Reference</div>
            </td>
          </tr>
          <tr *ngIf="compilation.issueDate">
            <td style="padding-right:1rem"><span class="label">Issue&nbsp;Date:</span></td>
            <td><span>{{compilation.issueDate | date : 'yyyy-MM-dd'}}</span></td>
          </tr>
          <tr *ngIf="compilation.code">
            <td><span class="label">Doc&nbsp;No:</span></td>
            <td><span>{{getTitle(true)}}</span></td>
          </tr>
          <tr *ngIf="compilation.editCount && !['IN', 'PFIN'].includes(typeData.get(compilation.type).code)">
            <td><span class="label">Edit:</span></td>
            <td><span>{{(compilation.editCount < 10 ? '0' : '') + compilation.editCount}}</span></td>
          </tr>
          <tr *ngIf="compilation.internal || tree?.linkedFC?.code || tree?.linkedOR?.code">
            <td><span class="label">Internal:</span></td>
            <td><span>{{compilation.internal || tree?.linkedFC?.code || tree?.linkedOR?.code}}</span></td>
          </tr>
          <tr *ngIf="compilation.supplierReference">
            <td><span class="label">Quotation&nbsp;Ref:</span></td>
            <td><span>{{compilation.supplierReference}}</span></td>
          </tr>

          <tr *ngIf="compilation.customerDocumentNumber || compilation.customerDocumentDate">
            <td colspan="2">
              <div class="section-header">Customer Reference</div>
            </td>
          </tr>
          <tr *ngIf="compilation.customerName">
            <td><span class="label">Name</span></td>
            <td><span>{{getCustomerReferenceName()}}</span></td>
          </tr>
          <tr *ngIf="compilation.customerDocumentNumber">
            <td><span class="label">Doc&nbsp;No:</span></td>
            <td><span>{{compilation.customerDocumentNumber}}</span></td>
          </tr>
          <tr *ngIf="compilation.customerDocumentDate">
            <td><span class="label">Date:</span></td>
            <td><span>{{compilation.customerDocumentDate | date : 'yyyy-MM-dd'}}</span></td>
          </tr>
          <tr *ngIf="compilation.customerPoPosition">
            <td><span class="label">PO&nbsp;Position:</span></td>
            <td><span>{{compilation.customerPoPosition}}</span></td>
          </tr>
          <tr *ngIf="compilation.partialDelivery?.el && compilation.partialDelivery?.of">
            <td><span class="label">Partial&nbsp;Delivery:</span></td>
            <td><span>{{compilation.partialDelivery.el}} / {{compilation.partialDelivery.of}}</span></td>
          </tr>

          <tr *ngIf="compilation.transportRun?.relatedCS?.length">
            <td colspan="2">
              <div class="section-header">Shipment Reference</div>
            </td>
          </tr>
          <tr *ngIf="compilation.transportRun?.relatedCS?.length">
            <td><span class="label">Related CS:</span></td>
            <td>
              <span>{{ compilation.transportRun?.relatedCS }}</span>
            </td>
          </tr>
          <tr><td>&nbsp;</td></tr>
        </table>

      </td>
      <td>
        <!~~ ===================================== delivery address, place of loading, service provided ... ================================================================= ~~>
        <div class="mid-info">
          <ul class="flex-outer">
            <ng-container *ngIf="!['DN'].includes(typeData.get(compilation.type).code)">
              <li *ngIf="!isEmpty(compilation.deliveryAddress) && (!compilation.invoiceType || compilation.invoiceType == 'delivery')">
                <div class="section-header">Delivery Address</div>
              </li>
              <li *ngIf="!isEmpty(compilation.deliveryAddress) && (!compilation.invoiceType || compilation.invoiceType == 'delivery')">
                <span class="label" style="display:none">Delivery Address</span>
                <div class="textbox">{{compilation.deliveryAddress}}</div>
                <div class="textbox" *ngIf="compilation.deliveryContact"><i>Contact:</i><br>{{compilation.deliveryContact}}</div>
              </li>
            </ng-container>

            <li *ngIf="!isEmpty(compilation.pickUpAddress) && (!compilation.invoiceType || compilation.invoiceType == 'pickup')">
              <div class="section-header">Pick-up Address</div>
            </li>
            <li *ngIf="!isEmpty(compilation.pickUpAddress) && (!compilation.invoiceType || compilation.invoiceType == 'pickup')">
              <span class="label" style="display:none">Pick-up address</span>
              <div class="textbox">{{compilation.pickUpAddress}}</div>
              <div class="textbox" *ngIf="compilation.pickUpContact"><i>Contact:</i><br>{{compilation.pickUpContact}}</div>
            </li>

            <li *ngIf="!isEmpty(compilation.serviceProvided) && (!compilation.invoiceType || compilation.invoiceType == 'service')">
              <div class="section-header">Service Provided</div>
            </li>
            <li *ngIf="!isEmpty(compilation.serviceProvided) && (!compilation.invoiceType || compilation.invoiceType == 'service')">
              <span class="label" style="display:none">Service Provided</span>
              <div class="textbox">{{compilation.serviceProvided}}</div>
            </li>
            <li *ngIf="data.visibleMap.placeOfLoading && !isEmpty(compilation.placeOfLoading) && (!compilation.invoiceType || compilation.invoiceType != 'service')">
              <!~~ <div class="section-header">{{['SPO', 'SPC', 'PFSPO', 'OC', 'DN','PL'].includes(typeData.get(compilation.type).code) && compilation.invoiceType === 'pickup' ? 'Place of delivery' : 'Place of loading'}}</div> ~~>
              <div class="section-header">{{compilation.invoiceType === 'pickup' ? 'Place of delivery' : 'Place of loading'}}</div>
              <div class="textbox">{{compilation.placeOfLoading}}</div>
              <div class="textbox" *ngIf="compilation.placeOfLoadingContact"><i>Contact:</i><br>{{compilation.placeOfLoadingContact}}</div>
            </li>
          </ul>
        </div>
      </td>
      <td>
        <!~~ =================================================== manufacturer, importer ====================================================================== ~~>
        <div class="right-info">
          <ul class="flex-outer">
            <li *ngIf="!isEmpty(compilation.manufacturerServiceproviderAddress)">
              <div class="section-header">{{compilation.invoiceType === 'service' ? 'Serviceprovider' : 'Manufacturer'}}</div>
            </li>
            <li *ngIf="!isEmpty(compilation.manufacturerServiceproviderAddress)">
              <span class="label" style="display:none">&nbsp;</span>
              <div class="textbox">{{compilation.manufacturerServiceproviderAddress}}</div>
              <div class="textbox" *ngIf="compilation.manufacturerContact"><i>Contact:</i><br>{{compilation.manufacturerContact}}</div>
            </li>
            <li *ngIf="data.visibleMap.importerInfo && !isEmpty(compilation.importerAddress) && (!compilation.invoiceType || compilation.invoiceType != 'service')">
              <div class="section-header">Importer Information</div>
            </li>
            <li *ngIf="data.visibleMap.importerInfo && !isEmpty(compilation.importerAddress) && (!compilation.invoiceType || compilation.invoiceType != 'service')">
              <div class="section-header" style="display:none">Importer Information</div>
              <div class="textbox">{{compilation.importerAddress}}</div>
            </li>
            <li *ngIf="((tree?.linkedCSs && tree?.linkedCSs[0]?.meansOfTransport) || compilation.meansOfTransport) && (!compilation.invoiceType || compilation.invoiceType != 'service')">
              <div class="section-header">Transportation</div>
              <div class="textbox">Carrier / Method<br>{{tree?.linkedCS?.meansOfTransport || compilation.meansOfTransport}}</div>
            </li>
            <li *ngIf="compilation.trackingCode">
              <div class="section-header">Tracking Code</div>
              <div class="textbox" *ngIf="compilation.trackingCode">{{compilation.trackingCode}}</div>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </table>
-->  
  <!-- =================================================== report fields ====================================================================== -->

  <ngx-report-dates [compilation]="compilation" [print]="true"></ngx-report-dates>


  <div *ngIf="['OF'].includes(typeData.get(compilation.type)?.code) && compilation.offerDisclaimer" style="margin-top:1rem">
    <p>Please note that the quoted quantity may deviate from confirmed delivery quantity, depending on our MOQ, which will be determined upon dispatch from our factory.</p>
    <p>Thank you for your understanding.</p>
    <p>Bitte beachten Sie, dass die angegebene Menge von der bestätigten Liefermenge abweichen kann, je nach unserer Mindestbestellmenge, die beim Versand aus unserem Werk festgelegt wird. </p>
    <p>Vielen Dank für Ihr Verständnis.</p>
  </div>
  <!-- =================================================== line items / deductibles / summary ====================================================================== -->

  <div *ngIf="!data.visibleMap.combinedShipment" class="print-item-section">

    <ng-template #lineItemsRef let-lineItems let-optional="optional">

      <ng-container *ngFor="let item of lineItems; let idx = index; first as isFirst; last as isLast">

        <!-- line items -->
        <div class="print-item-non-breakable">

          <b *ngIf="isFirst">Line Items</b>
          <div class="print-item print-item-header" *ngIf="isFirst">
            <table>
              <tr>
                <td>Pos</td>
                <td>Description</td>
                <td>Quantity</td>
                <td>Unit</td>
                <td *ngIf="data.visibleMap.prices" >Price/Unit</td>
                <td *ngIf="data.visibleMap.prices" style="padding-right:2.5mm">Net</td>
                <td *ngIf="data.visibleMap.vat">VAT</td>
                <td *ngIf="showGrossWeight">GW</td>
              </tr>
            </table>
          </div>
    
          <div [ngClass]="{'print-item': true, 'print-item-odd': idx % 2 == 1 }">

            <table>
              <tr>
                <!-- POS -->
                <td>{{$any(item).position.posOverride || (data.getPositionNumberFormat(this.compilation) | printf : idx + 1)}}</td>

                <!-- finished product / attr., publ. remark / date of delivery / order pos / partial delivery -->
                <td>
                  <div class="textbox" style="padding-bottom:5pt">{{item.productName}}</div>
                  <div *ngIf="!isEmpty(item.attributeRemark, true) || !isEmpty(item.attributeCode, true)" class="textbox print-item-additional">
                    <div *ngIf="!isEmpty(item.attributeRemark, true)">{{item.attributeRemark}}</div>
                    <div *ngIf="!isEmpty(item.attributeCode, true)">{{item.attributeCode}}</div>
                  </div>
                  <div *ngIf="!isEmpty(item.publicRemark, true)" class="textbox print-item-additional">{{item.publicRemark}}</div>
                  <div *ngIf="!isEmpty(item.adminText, true) || (!isEmpty(item.dateOfDelivery, true) && data.visibleMap.lineItemDateOfDelivery)" class="textbox print-item-additional">
                    <ng-container *ngIf="item.dateOfDelivery && data.visibleMap.lineItemDateOfDelivery">Customer Requested Delivery Date: {{item.dateOfDelivery | date : 'yyyy-MM-dd'}}</ng-container>
                    <ng-container *ngIf="!isEmpty(item.adminText, true)"><br />{{item.adminText}}</ng-container>
                  </div>
                  <!-- <div *ngIf="(data.visibleMap.lineItemOrderPos || data.readOnlyMap.lineItemOrderPos) && tree.linkedOC?.lineItems[idx]?.position?.orderPos !== -2">
                    {{this.compilation?.customerDocumentNumber}};&nbsp;&nbsp;&nbsp;
                    {{tree.linkedOC?.lineItems[idx]?.position?.orderPos >= 0 ? 'Pos: '+(tree.linkedOC?.lineItems[idx]?.position?.orderPos+1)+';' : ''}}&nbsp;&nbsp;&nbsp;
                    {{tree.linkedOC?.lineItems[idx]?.partialDelivery?.sum >= 0 ?
                      'Delivery: '+tree.linkedOC?.lineItems[idx]?.partialDelivery?.num+' / '+tree.linkedOC?.lineItems[idx]?.partialDelivery?.sum : '' }}
                  </div> -->
                  <div *ngIf="(data.visibleMap.lineItemOrderPos || data.readOnlyMap.lineItemOrderPos) && tree.getItemOrderPos(item)">
                    <span *ngIf="item.poVisibility?.poNum">{{this.compilation?.customerDocumentNumber}};</span>
                    <span *ngIf="item.poVisibility?.poPos">
                      &nbsp;&nbsp;&nbsp;Pos:
                      {{tree.getItemOrderPos(item)}}&nbsp;&nbsp;&nbsp;
                    </span>
                    <span *ngIf="item.poVisibility?.poDelivery">
                      {{tree.linkedOC?.lineItems[idx]?.partialDelivery?.sum >= 0 ?
                        'Delivery: '+tree.linkedOC?.lineItems[idx]?.partialDelivery?.num+' / '+tree.linkedOC?.lineItems[idx]?.partialDelivery?.sum : '' }}
                    </span>
                  </div>
                </td>

                <!-- quantity -->
                <td>
                  <div [ngClass]="{'textline':1,'discount':isDiscount()}">{{item.quantity | number : '1.2-2' : 'de' }}</div>
                  <div *ngIf="unitOptions.get(item.displayUnit).id != 1" [ngClass]="{'display-unit':1,'textline':1,'discount':isDiscount()}">{{item.displayUnitQuantity | number : '1.2-2' : 'de' }}</div>
                  <div *ngIf="isPartialPayment()" [ngClass]="{'display-unit':1,'print-item-additional':1,'textline':1,'discount':isDiscount()}">
                    <span style="font-size:unset;color:unset;">
                      {{item.invoicePercent}}% of &nbsp;&nbsp;
                    </span>
                    {{item.quantity | number : '1.2-2' : 'de' }}
                  </div>
                  <!-- <ng-container *ngIf="isPartialPayment()">
                    <div [ngClass]="{'textline':1,'discount':isDiscount()}">{{item.quantity | number : '1.2-2' : 'de' }}</div>
                    <div *ngIf="unitOptions.get(item.displayUnit).id != 1" [ngClass]="{'display-unit':1,'textline':1,'discount':isDiscount()}">{{item.displayUnitQuantity | number : '1.2-2' : 'de' }}</div>
                    <div [ngClass]="{'textline':1,'discount':isDiscount()}">{{item.quantity | number : '1.2-2' : 'de' }}</div>
                  </ng-container>
                  <ng-container *ngIf="!isPartialPayment()">
                    <div [ngClass]="{'textline':1,'discount':isDiscount()}">{{item.quantity | number : '1.2-2' : 'de' }}</div>
                    <div *ngIf="unitOptions.get(item.displayUnit).id != 1" [ngClass]="{'display-unit':1,'textline':1,'discount':isDiscount()}">{{item.displayUnitQuantity | number : '1.2-2' : 'de' }}</div>
                  </ng-container> -->

                  <!-- <div [ngClass]="{'textline':1,'discount':isDiscount()}">{{item.quantity | number : '1.2-2' : 'de' }}</div>
                  <div [ngClass]="{'display-unit':1,'textline':1,'partial-payment':isPartialPayment(),'discount':isDiscount()}" *ngIf="unitOptions.get(item.displayUnit).id != 1">
                    <span *ngIf="isPartialPayment()" style="padding-right:1em">{{item.invoicePercent}}% of </span>
                    {{item.displayUnitQuantity | number : '1.2-2' : 'de' }}
                  </div>
                  <div class="display-unit textline print-item-additional" *ngIf="isPartialPayment()">{{item.displayUnitQuantity | number : '1.2-2' : 'de' }}</div> -->
                </td>

                <!-- unit -->
                <td>
                  <div [ngClass]="{'textline':1,'discount':isDiscount()}">pc.</div>
                  <div *ngIf="unitOptions.get(item.displayUnit).id != 1" [ngClass]="{'display-unit':1,'textline':1,'discount':isDiscount()}">{{unitOptions.get(item.displayUnit).short}}</div>
                  <div *ngIf="isPartialPayment()" [ngClass]="{'display-unit':1,'print-item-additional':1,'textline':1,'discount':isDiscount()}">pc.</div>
                  <!-- <div [ngClass]="{'textline':1,'discount':isDiscount()}">pc. <span *ngIf="unitOptions.get(item.displayUnit).id != 1 && !data.visibleMap.prices"></span></div>
                  <div [ngClass]="{'display-unit':1,'textline':1,'partial-payment':isPartialPayment(),'discount':isDiscount()}" *ngIf="unitOptions.get(item.displayUnit).id != 1">{{unitOptions.get(item.displayUnit).short}}</div>
                  <div class="display-unit textline print-item-additional" *ngIf="isPartialPayment()">{{unitOptions.get(item.displayUnit).short}}</div> -->
                </td>

                <!-- price / unit -->
                <td *ngIf="data.visibleMap.prices">
                  <div [ngClass]="{'textline':1,'discount':isDiscount()}"  *ngIf="item.piecePrice !== item.calculatedPiecePrice">
                    {{ (isPartialPayment() ? item.piecePrice * item.invoicePercent/100 : item.piecePrice) | currency : compilation.currency : 'symbol' : '1.3-7' : 'de' }}</div>
                  <div [ngClass]="{'textline':1,'discount':isDiscount()}"  *ngIf="item.piecePrice === item.calculatedPiecePrice">
                    {{ (isPartialPayment() ? item.piecePrice * item.invoicePercent/100 : item.piecePrice) | currency : compilation.currency : 'symbol' : '1.3-10' : 'de' }}</div>

                  <div *ngIf="item.piecePrice !== item.calculatedPiecePrice && unitOptions.get(item.displayUnit).id != 1" [ngClass]="{'display-unit':1,'textline':1,'discount':isDiscount()}">{{item.displayUnitPrice | currency : compilation.currency : 'symbol' : '1.3-7' : 'de' }}</div>
                  <div *ngIf="item.piecePrice === item.calculatedPiecePrice && unitOptions.get(item.displayUnit).id != 1" [ngClass]="{'display-unit':1,'textline':1,'discount':isDiscount()}">{{item.displayUnitPrice | currency : compilation.currency : 'symbol' : '1.3-10' : 'de' }}</div>

                  <div class="textline print-item-additional display-unit" *ngIf="item.piecePrice !== item.calculatedPiecePrice && isPartialPayment()">{{item.piecePrice | currency : compilation.currency : 'symbol' : '1.3-7' : 'de' }}</div>
                  <div class="textline print-item-additional display-unit" *ngIf="item.piecePrice === item.calculatedPiecePrice && isPartialPayment()">{{item.piecePrice | currency : compilation.currency : 'symbol' : '1.3-10' : 'de' }}</div>
                </td>

                <!-- net price -->
                <td *ngIf="data.visibleMap.prices">
                  <div [ngClass]="{'textline':1,'discount':isDiscount()}">{{ (isPartialPayment() ? item.quantity * item.piecePrice  * item.invoicePercent/100 : item.quantity * item.piecePrice) | currency : compilation.currency : 'symbol' : '1.3-7' : 'de' }}</div>
                  <!-- <div *ngIf="unitOptions.get(item.displayUnit).id != 1" [ngClass]="{'display-unit':1,'textline':1,'discount':isDiscount()}">{{item.quantity * item.displayUnitPrice | currency : compilation.currency : 'symbol' : '1.3-7' : 'de' }}</div> -->
                  <div class="textline print-item-additional display-unit" *ngIf="isPartialPayment()">{{item.quantity * item.piecePrice | currency : compilation.currency : 'symbol' : '1.3-7' : 'de' }}</div>
                </td>
                <!-- <td *ngIf="data.visibleMap.prices">
                  <div [ngClass]="{'textline':1,'discount':isDiscount()}">{{(item.quantity*item.piecePrice) | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</div>
                  <div class="textline print-item-additional" *ngIf="isPartialPayment()">{{(item.quantity*item.piecePrice*item.invoicePercent/100) | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</div>
                </td> -->

                <!-- vat -->
                <td *ngIf="data.visibleMap.vat" [ngClass]="{'vat-highlight': compilation.vatGlobal != item.VATPercent}">
                    <!-- <div *ngIf="isPartialPayment()" class="textline partial-payment">&nbsp;</div> -->
                    <div *ngIf="!isDiscount()" [ngClass]="{'textline':1}">{{item.VATPercent}}%</div>
                </td>

                <!-- gross weight -->
                <td *ngIf="showGrossWeight">{{item.weight ? item.weight + ' kg' : ''}}</td>
            </tr>

              <!-- discount -->

              <tr *ngIf="data.visibleMap.discount && isDiscount(item)">
                <td></td>
                <td style="text-align:right;padding-right:2em;">
                  <ng-container *ngIf="item.discount">Discount:&nbsp;{{item.discount}}%</ng-container>
                </td>
                <td>
                  <div [ngClass]="{'textline':1}" *ngIf="unitOptions.get(item.displayUnit).id != 1">{{item.quantity | number : '1.2-2' : 'de' }}</div>
                  <div [ngClass]="{'textline':1,'print-item-additional':1}">( {{item.displayUnitQuantity | number : '1.2-2' : 'de' }}</div>
                </td>
                <td>
                  <div [ngClass]="{'textline':1}"  *ngIf="unitOptions.get(item.displayUnit).id != 1">pc. <span *ngIf="unitOptions.get(item.displayUnit).id != 1 && !data.visibleMap.prices">)</span></div>
                  <div [ngClass]="{'textline':1,'print-item-additional':1}">{{unitOptions.get(item.displayUnit).short}}</div>
                </td>
                <td *ngIf="data.visibleMap.prices">
                  <div [ngClass]="{'textline':1}"  *ngIf="unitOptions.get(item.displayUnit).id != 1">
                    {{item.piecePrice * (100-item.discount)/100 | currency : compilation.currency : 'symbol' : '1.3-3' : 'de' }}
                  </div>
                  <div [ngClass]="{'textline':1,'print-item-additional':1}">{{item.displayUnitPrice * (100-item.discount)/100 | currency : compilation.currency : 'symbol' : '1.3-3' : 'de' }} )</div>
                </td>
                <td *ngIf="data.visibleMap.prices">
                  <div [ngClass]="{'textline':1}">{{(item.quantity*item.piecePrice*(100-item.discount)/100) | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</div>
                </td>
                <td *ngIf="data.visibleMap.vat">
                  <div [ngClass]="{'textline':1}">{{item.VATPercent}}%</div>
                </td>
              </tr>

              <!-- HS code / OBIC / expiry -->

              <tr *ngIf="!isEmpty(item.hsCode, true) || !isEmpty(obicCodes, true) || !isEmpty(item.expiryDate, true) || !isEmpty(item.factoryOrderNumber, true) 
                || !isEmpty(item.numberOfTC, true) || !isEmpty(item.dateOfProduction, true) || !isEmpty(item.dateOfTC, true)">
                <td></td>
                <td [attr.colspan]="data.visibleMap.prices ? 6 : 3">
                  <div>
                    <table class="hs-obic-exp">
                      <td *ngIf="!isEmpty(item.hsCode)"><div>HS Code:</div><div>{{item.hsCode}}</div></td>

                      <td *ngIf="!isEmpty(item.countryOfOrigin)"><div>Country of Origin:</div><div>{{item.countryOfOrigin}}</div></td>

                      <td *ngIf="!isEmpty(obicCodes[idx], true) && data.visibleMap.lineItemOBIC">
                        <div>OBIC:</div><div>{{obicCodes[idx]}}</div>
                      </td>
                      <!-- <td *ngIf="!isEmpty(item.tbCode)"><div>OBIC:</div><div>{{item.tbCode}}</div></td> -->
                      <ng-container *ngIf="item.tcChecked && (data.visibleMap.lineItemBoxEditBlock || data.visibleMap.lineItemBoxReadOnlyBlock)">
                        <td *ngIf="!isEmpty(item.tbCode) || boxBlockValues[idx].tbCode" style="width:auto;max-width:8.5rem">
                          <div>OBIC:</div>
                          <!-- <div *ngIf="data.visibleMap.lineItemBoxEditBlock">{{item.factoryOrderNumber}}</div> -->
                          <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].tbCode || item.tbCode}}</div>
                        </td>
                        <td *ngIf="!isEmpty(item.factoryOrderNumber) || boxBlockValues[idx].factoryOrderNumber" style="width:auto;max-width:8.5rem">
                          <div>Factory order number:</div>
                          <!-- <div *ngIf="data.visibleMap.lineItemBoxEditBlock">{{item.factoryOrderNumber}}</div> -->
                          <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].factoryOrderNumber}}</div>
                        </td>
                        <td *ngIf="!isEmpty(item.numberOfTC) ||boxBlockValues[idx].numberOfTC" style="width:auto;max-width:8.5rem">
                          <div>No of test report:</div>
                          <!-- <div *ngIf="data.visibleMap.lineItemBoxEditBlock">{{item.numberOfTC}}</div> -->
                          <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].numberOfTC}}</div>
                        <td *ngIf="!isEmpty(item.dateOfTC) || boxBlockValues[idx].dateOfTC" style="white-space:nowrap">
                          <div>Date of TC:</div>
                          <!-- <div *ngIf="data.visibleMap.lineItemBoxEditBlock">{{item.dateOfTC | date : 'yyyy-MM-dd'}}</div> -->
                          <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].dateOfTC}}</div>
                        </td>
                        <td *ngIf="!isEmpty(item.dateOfProduction) || boxBlockValues[idx].dateOfProduction" style="white-space:nowrap">
                          <div>Prod Date (min):</div>
                          <!-- <div *ngIf="data.visibleMap.lineItemBoxEditBlock">{{item.dateOfProduction | date : 'yyyy-MM-dd'}}</div> -->
                          <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].minProdDate}}</div>
                        </td>
                        <td *ngIf="!isEmpty(item.dateOfProduction) || boxBlockValues[idx].dateOfProduction" style="white-space:nowrap">
                          <div>Prod Date (max):</div>
                          <!-- <div *ngIf="data.visibleMap.lineItemBoxEditBlock">{{item.dateOfProduction | date : 'yyyy-MM-dd'}}</div> -->
                          <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].maxProdDate}}</div>
                        </td>
                        <td *ngIf="!isEmpty(item.expiryDate) || boxBlockValues[idx].expiryDate" style="white-space:nowrap">
                          <div>Expiry date:</div>
                          <!-- <div *ngIf="data.visibleMap.lineItemBoxEditBlock">{{item.expiryDate | date : 'yyyy-MM-dd'}}</div> -->
                          <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].expiryDate}}</div>
                        </td>
                      </ng-container>
                    </table>
                    <!-- <span *ngIf="!isEmpty(item.hsCode)"  mr-4"><span>HS code:</span> {{item.hsCode}}</span>
                    <span *ngIf="!isEmpty(item.tbCode)" class="hs-obic-exp mr-4"><span>OBIC:</span> {{item.tbCode}}</span>
                    <ng-container *ngIf="compilation.visibleFields.includes('liTC' + item.position.internalPos)">
                      <span *ngIf="!isEmpty(item.factoryOrderNumber)" class="hs-obic-exp mr-4"><span>Factory order number:</span> {{item.factoryOrderNumber}}</span>
                      <span *ngIf="!isEmpty(item.numberOfTC)" class="hs-obic-exp mr-4"><span>No of test report:</span> {{item.numberOfTC}}</span>
                      <span *ngIf="!isEmpty(item.dateOfTC)" class="hs-obic-exp mr-4"><span>Date of TC:</span> {{item.dateOfTC | date : 'yyyy-MM-dd'}}</span>
                      <span *ngIf="!isEmpty(item.dateOfProduction)" class="hs-obic-exp mr-4"><span>Date of production:</span> {{item.dateOfProduction | date : 'yyyy-MM-dd'}}</span>
                      <span *ngIf="!isEmpty(item.expiryDate)" class="hs-obic-exp mr-4"><span>Expiry date:</span> {{item.expiryDate | date : 'yyyy-MM-dd'}}</span>
                    </ng-container> -->
                  </div>
                </td>
                <!-- <td></td>
                <td></td> -->
                <!-- <td *ngIf="data.visibleMap.prices"></td>
                <td *ngIf="data.visibleMap.prices"></td>
                <td *ngIf="data.visibleMap.vat"></td> -->
              </tr>

              <tr *ngIf="item.showCustomerProductSpecification && !isEmpty(item.finishedProduct?.customerProductSpecification)">
                <td></td>
                <td colspan="100">
                  <span *ngIf="item.finishedProduct.customerProductSpecification[0]?.comment">
                    <span style="color:gray;margin-right:1em">Customer Product Specification:</span> {{item.finishedProduct.customerProductSpecification[0]?.comment}}
                  </span>
                  <span *ngIf="item.finishedProduct.customerProductSpecification[0]?.additionalField">
                    <span style="color:gray;margin:0 1em">Revision:</span> {{item.finishedProduct.customerProductSpecification[0]?.additionalField}}
                  </span>
                  <span *ngIf="item.finishedProduct.customerProductSpecification[0]?.additionalDate">
                    <span style="color:gray;margin:0 1em">Date of Release:</span> {{item.finishedProduct.customerProductSpecification[0]?.additionalDate | date : 'yyyy-MM-dd'}}
                  </span>
                </td>
              </tr>
              <!-- <tr *ngIf="item.finishedProduct?.content.energy 
                && !item.finishedProduct.customerProductSpecification?.length 
                && item.finishedProduct.showMissingCpsWarning
                && ['OR', 'OC'].includes(typeData.get(compilation.type).code)">
                <td></td>
                <td colspan="100">
                  <span style="color:gray">No customer specification available</span>
                </td>
              </tr> -->
      
            </table>
          </div>
          

          <!-- line items (subtotal) net -->

          <div class="border-item-summary" *ngIf="isLast && !optional">
            <table *ngIf="data.visibleMap.prices && compilation.lineItems?.length > 0" style="background-color:white;border:none">
              <tr>
                <td>&nbsp;</td>
                <td *ngIf="data.visibleMap.prices" [ngClass]="{'gray-italic': isPartialPayment()}"
                  style="width:45mm;text-align:right;padding-right:0.5em!important">
                  {{compilation.deductibleItems.length > 0 ? 'Line Items Subtotal:' : 'Line Items Total:'}}</td>
                <td *ngIf="data.visibleMap.prices" style="width:26mm;text-align:right" [ngClass]="{'gray-italic': isPartialPayment()}">
                  {{subTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="data.visibleMap.vat" style="width: 8mm">&nbsp;</td>
              </tr>
              <tr *ngIf="data.visibleMap.invoicePayment && isPartialPayment()">
                <td>&nbsp;</td>
                <td *ngIf="data.visibleMap.prices" style="width:45mm;text-align:right;padding-right:0.5em">
                  {{getPercentText() + (compilation.deductibleItems.length > 0 ? 'Line Items Subtotal:' : 'Line Items Total:')}}</td>
                <td *ngIf="data.visibleMap.prices" style="width:26mm;text-align:right">{{partialSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="data.visibleMap.vat" style="width: 8mm">&nbsp;</td>
              </tr>      
              <tr *ngIf="data.visibleMap.discount && isDiscount()">
                <td>&nbsp;</td>
                <td *ngIf="data.visibleMap.prices" style="width:45mm;text-align:right;padding-right:0.5em">
                  {{(compilation.deductibleItems.length > 0 ? 'Discounted Subtotal Net:' : 'Discounted Total:')}}</td>
                <td *ngIf="data.visibleMap.prices" style="width:26mm;text-align:right">{{discountedSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="data.visibleMap.vat" style="width: 8mm">&nbsp;</td>
              </tr>      
            </table>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <ng-container *ngTemplateOutlet="lineItemsRef; context: {  $implicit: compilation.lineItems }"></ng-container>

    <!-- deductible items -->

    <div class="print-item-non-breakable print-item-section" *ngIf="data.visibleMap.prices && compilation.deductibleItems?.length > 0">
      <b>Other Items</b>
      <div class="print-item print-item-header">
        <div>
          <table>
            <tr>
              <td>Pos</td>
              <td>Items</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td style="padding-right:2.5mm">NET</td>
              <td *ngIf="data.visibleMap.vat">VAT</td>
            </tr>
          </table>
        </div>
      </div>
      <ng-container *ngFor="let item of compilation.deductibleItems; let idx = index; last as isLast">
        <div [ngClass]="{'print-item': true, 'print-item-odd': idx % 2 == 1 }">
          <table>
            <tr>
              <td style="text-align:center">{{compilation.lineItems?.length + idx + 1 | nrkPad : 2}}</td>
              <td>
                <div class="textbox">{{item.description}}</div>
              </td>
              <td colspan="1" style="text-align:right">
                  <div class="textline" style="width:23mm">{{item.value | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</div>
                </td>
              <td *ngIf="data.visibleMap.vat" style="width: 8mm;text-align:center">{{compilation.vatGlobal}}%</td>
                </tr>
          </table>
        </div>
        <div class="border-item-summary" *ngIf="isLast">
          <table *ngIf="data.visibleMap.prices && compilation.deductibleItems.length > 0" style="background-color:white;border:none">
            <tr>
              <td>&nbsp;</td>
              <td *ngIf="data.visibleMap.prices" colspan="2"
                style="width: 45mm;text-align:right;padding-right:0.5em!important">Other Items Subtotal:</td>
              <td *ngIf="data.visibleMap.prices" style="width:26mm;text-align:right;padding:4pt;">
                {{ deductibleTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
              <td *ngIf="data.visibleMap.vat" style="width: 8mm">&nbsp;</td>
            </tr>
          </table>
        </div>
        <!-- <div>
          <div class="print-item print-total" style="padding: 0" *ngIf="isLast">
            <table *ngIf="data.visibleMap.prices && compilation.deductibleItems.length > 0" style="background-color:white;border:none">
              <tr>
                <td style="width: 110mm">&nbsp;</td>
                <td *ngIf="data.visibleMap.prices" colspan="2" [ngClass]="{'gray-italic': isPartialPayment()}"
                  style="width: 12.5mm;text-align:right;padding-right:0.5em!important">Net total:</td>
                <td *ngIf="data.visibleMap.prices" [ngClass]="{'gray-italic': isPartialPayment()}">
                  {{ netTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="data.visibleMap.vat" style="width: 10mm">&nbsp;</td>
              </tr>
              <tr *ngIf="data.visibleMap.invoicePayment && isPartialPayment()">
                <td style="width: 110mm">&nbsp;</td>
                <td *ngIf="data.visibleMap.prices" colspan="2" style="width:12.5mm;text-align:right;padding-right:0.5em">
                  {{getPercentText()}}net total:</td>
                <td *ngIf="data.visibleMap.prices">{{ partialNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="data.visibleMap.vat" style="width: 10mm">&nbsp;</td>
              </tr>        
              <tr *ngIf="data.visibleMap.invoicePayment && isDiscount()">
                <td style="width: 110mm">&nbsp;</td>
                <td *ngIf="data.visibleMap.prices" colspan="2" style="width:12.5mm;text-align:right;padding-right:0.5em">
                  Discounted net total:</td>
                <td *ngIf="data.visibleMap.prices">{{ discountedNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="data.visibleMap.vat" style="width: 10mm">&nbsp;</td>
              </tr>        
            </table>
          </div>
        </div> -->
      </ng-container>
    </div>


    <!-- --------------- payment plan invoices ---------------------- -->

    <ngx-payment-plan-invoices *ngIf="data.visibleMap.paymentPlanInvoice" [compilation]="compilation" [print]="true"></ngx-payment-plan-invoices>
    <div *ngIf="this.data.paymentPlanHasInvoices(compilation)" class="border-item-summary">
      <table *ngIf="data.visibleMap.prices && compilation.deductibleItems.length > 0" style="background-color:white;border:none">
        <tr>
          <td>&nbsp;</td>
          <td *ngIf="data.visibleMap.prices" colspan="2"
            style="width: 45mm;text-align:right;padding-right:0.5em!important">Progress Payment Subtotal:</td>
          <td *ngIf="data.visibleMap.prices" style="width:26mm;text-align:right">
            {{ ppInvoicesTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
          <td *ngIf="data.visibleMap.vat" style="width: calc(8mm + 1pt)">&nbsp;</td>
        </tr>
      </table>
    </div>

    <!-- --------------- line items / deductibles / pp invoices - summary ---------------------- -->

    <div *ngIf="this.data.paymentPlanHasInvoices(compilation) || compilation.deductibleItems?.length" class="print-item-non-breakable" style="margin-top:2.5em;margin-bottom:1em">

      <b>Summary</b>
      <div class="print-total" style="font-weight:bold;padding-bottom:0">
        <table *ngIf="data.visibleMap.prices">
          <tr class="summary-payment-item">
            <td>&nbsp;</td>
            <td style="text-align:right">Line Items Subtotal:</td>
            <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right;width:26mm">{{subTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isPartialPayment()" style="text-align:right;width:26mm">{{partialSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isDiscount()" style="text-align:right;width:26mm">{{discountedSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td style="width:10mm;">&nbsp;</td>
          </tr>
          <tr *ngIf="compilation.deductibleItems?.length" class="summary-payment-item">
            <td>&nbsp;</td>
            <td style="text-align:right">Other Items Subtotal:</td>
            <td style="text-align:right;width:26mm">{{deductibleTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td style="width:10mm;">&nbsp;</td>
          </tr>
          <tr *ngIf="this.data.paymentPlanHasInvoices(compilation)" class="summary-payment-item">
            <td>&nbsp;</td>
            <td style="text-align:right">Progress Payment Subtotal:</td>
            <td style="text-align:right;width:26mm">{{ppInvoicesTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td style="width:10mm;">&nbsp;</td>
          </tr>
          <tr class="summary-payment-total">
            <td>&nbsp;</td>
            <td style="text-align:right">Total Net:</td>
            <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right;width:26mm">{{ppNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isPartialPayment()" style="text-align:right;width:26mm">{{ppPartialNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isDiscount()" style="text-align:right;width:26mm">{{ppDiscountedNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td style="width:10mm;">&nbsp;</td>
          </tr>
        </table>
      </div>
    </div>

    <!-- VAT items / payment summary -->

    <div class="print-item-non-breakable">
      <ng-container *ngIf="data.visibleMap.vat">

        <!-- VAT items -->
        <div class="print-item print-item-header print-item-section default-t-padding" *ngIf="vatItems.length > 0">
          <div>
            <table>
              <tr>
                <th style="width:28px"></th>
                <th style="text-align:left">VAT %</th>
                <th style="text-align:right;width:30mm">Liable to VAT</th>
                <th style="text-align:right;width:23mm">VAT</th>
                <th style="width:8mm">&nbsp;</th>
              </tr>
            </table>
          </div>
        </div>
        <ng-container *ngFor="let item of vatItems; let idx = index; last as isLast">
          <div class="print-item">
            <table>
              <tr>
                <td style="width:28px">&nbsp;</td>
                <td style="text-align:left">VAT {{item.vat}}%</td>
                <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right;width:30mm">
                  {{item.sum | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isPartialPayment()" style="text-align:right;width:30mm">
                  {{item.partialVat | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isDiscount()" style="text-align:right;width:30mm">
                  {{item.discountedVat | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>

                <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right;width:23mm">
                  {{item.sum * item.vat / 100 | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isPartialPayment()" style="text-align:right;width:23mm">
                  {{item.partialVat * item.vat / 100 | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isDiscount()" style="text-align:right;width:23mm">
                  {{item.discountedVat * item.vat / 100 | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td style="width:8mm">&nbsp;</td>
              </tr>
            </table>
          </div>

          <!-- payment summary (VAT / total to be paid) -->
          <!-- <div *ngIf="data.visibleMap.dueDate">
            <span class="textbox">Due date: {{compilation.dueDate | date : 'yyyy-MM-dd'}}</span>
          </div> -->
  

          <div class="print-total default-t-padding" style="margin-top:2.5em;margin-bottom:1em;" *ngIf="isLast">
            <table *ngIf="data.visibleMap.prices">
              <tr class="vat-total" *ngIf="data.visibleMap.vat">
                <td style="width:28px">&nbsp;</td>
                <td style="text-align:right">VAT Total:</td>
                <!-- <td style="text-align:right">{{(isPartialPayment()
                  ? partialVatTotal : vatTotal) | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td> -->
                <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right;width:30mm">{{vatTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="isPartialPayment()" style="text-align:right;width:30mm">{{partialVatTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="isDiscount()" style="text-align:right;width:30mm">{{discountedVatTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td style="width:8mm;padding-right:8pt">&nbsp;</td>
              </tr>
              <tr class="total-payment">
                <td style="width:28px">
                  <div style="position:relative"><div style="position:absolute;width:20rem;bottom:-0.6rem;left:2.5rem">
                    <span *ngIf="data.visibleMap.dueDate && compilation.dueDate && compilation.paymentPlan?.termsOfPayment !== 'NO COMMERCIAL VALUE - CUSTOMS PURPOSE ONLY'" style="font-weight: normal; text-transform: none">Due Date: {{compilation.dueDate | date : 'yyyy-MM-dd'}}</span>
                  </div></div>
                </td>
                <td style="text-align:right">{{compilation.type === 8 ? 'Total Credit:' : 'Total to Be Paid:'}}</td>
                <!-- <td style="text-align:right;width:23mm">{{(isPartialPayment()
                  ? partialSumTotal : sumTotal) | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td> -->
                <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right;width:30mm">{{sumTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="isPartialPayment()" style="text-align:right;width:30mm">{{partialSumTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td *ngIf="isDiscount()" style="text-align:right;width:30mm">{{discountedSumTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td style="width:8mm;padding-right:8pt">&nbsp;</td>
              </tr>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="data.visibleMap.optionalLineItems && compilation.optionalLineItems?.length">
      <br><br>
      <div class="print-item-non-breakable">
        <div class="mb-2"><b>Optional Line Items</b></div>
        <ng-container *ngTemplateOutlet="lineItemsRef; context: {  $implicit: compilation.optionalLineItems, optional: true }"></ng-container>
      </div>
    </ng-container>
  
  </div>

  <!-- combined shipment line items -->
  <div *ngIf="data.visibleMap.combinedShipment">
    <br>
    <ngx-combined-shipment
      [compilation]="compilation"
      [latestVersionItems]="latestVersionItems"
      [disabled]="true"
      [print]="true"
    ></ngx-combined-shipment>
    <br>
  </div>

  <!-- ======================================================= additional fields ... ================================================================== -->
  <div class="bottom-section">
    <ngx-document-sub-components #docFormAdditional [compilation]="this.compilation" [print]="true" [documentComponent]="this.documentComponent"
      [relatedDocuments]="relatedDocuments">
    </ngx-document-sub-components>
  </div>

  <!-- ======================================================= remark, tax-hint, ... ================================================================== -->
  <!-- <table class="issuer-footer">
    <tr>
      <td>BU: <span>{{getBusinessUnits()}}</span></td>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td>Issued by: <span>{{issuedBy}}</span></td>
      <td><span>{{getIssuer()}}</span></td>
    </tr>
  </table> -->

  <div *ngIf="data.visibleMap.poCheck" class="po-check print-item-break-before">
    <h2>PO Checklist ({{compilation.customerDocumentNumber}})</h2>
    <table>
      <!-- <thead>
        <th colspan="2">Formal Details</th>
        <th colspan="2">Position Details</th>
        <th colspan="2">Condition Details</th>
      </thead> -->
      <tbody>
        <tr>
          <th colspan="2">Formal Details</th>
          <th colspan="2">Position Details</th>
          <th colspan="2">Condition Details</th>
        </tr>
        <tr><td>Invoice Address     </td><td></td><td>Product Name / Position Text</td><td></td><td>Delivery Condition  </td><td></td></tr>
        <tr><td>Customer UID        </td><td></td><td>Quantity                    </td><td></td><td>Payment Condition   </td><td></td></tr>
        <tr><td>Delivery Address    </td><td></td><td>Price / Unit                </td><td></td><td>Payment Plan        </td><td></td></tr>
        <tr><td>Issuer              </td><td></td><td>Total Position Price NET    </td><td></td><td>Tax Hint            </td><td></td></tr>
        <tr><td>NRK Banking Details </td><td></td><td>Total Price NET             </td><td></td><td>                    </td><td></td></tr>
        <tr><td>                    </td><td></td><td>Applicable VAT              </td><td></td><td>                    </td><td></td></tr>
        <tr><td colspan="6" style="height:3em;text-align:center">Deviations need written confirmation before continuing with OC</td></tr>
        <tr><th colspan="6" >Order confirmation check</th></tr>
        <tr><td>OCs issued          </td><td></td><td>OC email filed in PO admin emails</td><td></td><td> </td><td></td></tr>
        <tr><td>OC sent to customer </td><td></td><td>OC confirmed by factory</td><td></td><td></td><td></td></tr>
        <tr><td colspan="6" style="height:3em;text-align:center">Hard copy filed only after double check of OCs</td></tr>
        <tr><td colspan="6" style="height:3em">
          <div style="display:flex;padding:0.5rem 0;max-height:5.6rem;overflow:hidden" *ngIf="
            compilation.invoiceSendTo?.length || documentComponent.invoiceSendTo?.length
            || documentComponent.deliveryNoteSendTo?.length
            || documentComponent.testCertificateSendTo?.length
            || documentComponent.invoiceReminderSendTo?.length
          ">
            <div *ngIf="compilation.invoiceSendTo?.length || documentComponent.invoiceSendTo?.length" class="send-to-section">
              <div><b>Send IN to:</b></div>
              <div class="send-to-info">{{compilation.invoiceSendTo || documentComponent.invoiceSendTo}}</div>
            </div>
            <div *ngIf="documentComponent.deliveryNoteSendTo?.length" class="send-to-section">
              <div><b>Send DN to:</b></div>
              <div class="send-to-info">{{documentComponent.deliveryNoteSendTo}}</div>
            </div>
            <div *ngIf="documentComponent.testCertificateSendTo?.length" class="send-to-section">
              <div><b>Send TC to:</b></div>
              <div class="send-to-info">{{documentComponent.testCertificateSendTo}}</div>
            </div>
            <div *ngIf="documentComponent.invoiceReminderSendTo?.length" class="send-to-section">
              <div><b>Send Invoice Reminder to:</b></div>
              <div class="send-to-info">{{documentComponent.invoiceReminderSendTo}}</div>
            </div>                
          </div>
          <div style="padding:0.5rem 0;max-height:5rem;overflow:hidden;" *ngIf="documentComponent.businessGeneralInfo">
            <div><b>General Information:</b></div>
            <div class="send-to-info">{{documentComponent.businessGeneralInfo}}</div>
          </div>
        </td></tr>
        <tr><td colspan="6" style="height:12em;vertical-align:top;">Remarks</td></tr>
        <tr><td colspan="6" style="height:3em;">
          <div>Issued by: {{data.userName(compilation.issuedBy)}}</div>
          <div>Date & Signature</div>
        </td></tr>
        <tr><td colspan="6" style="height:3em;">
          <div>Checked by:</div>
          <!-- <hr/> -->
          <div>Date & Signature</div>
        </td></tr>
      </tbody>
    </table>
  </div>

  <div class="pdf-footer">
    <table style="width: 100%; border-top: 1px solid black;">
      <tr>
        <td>
          <div style="text-align:center;white-space:pre;font-size:smaller;">{{compilation.documentFooter?.address}}</div>
        </td>
        <td>
          <div style="text-align:center;white-space:pre;font-size:smaller;">{{compilation.documentFooter?.registry}}</div>
        </td>
        <td>
          <div style="text-align:center;white-space:pre;font-size:smaller;">{{compilation.documentFooter?.bank}}</div>
        </td>
        <td></td>
      </tr>
    </table>      
  </div>

</div>

<div *ngIf="buttons" class="doc-footer hidden">
  <button class="btn btn-default btn-md" (click)="onClosePreview()">Back</button>
  <button *ngIf="compilation.type != 5 || (!compilation.draft && compilation.invoiceDownloaded === false)" class="btn btn-info btn-md" (click)="onDownloadPdf()">Document</button>
  <!-- <button *ngIf="compilation.type == 5 && compilation.invoiceDownloaded !== false"class="btn btn-info btn-md" (click)="onDownloadPdf(false, true)">PDF Copy</button> -->
  <button *ngIf="compilation.type == 5 && (compilation.invoiceDownloaded !== false || compilation.draft)"class="btn btn-info btn-md" (click)="onDownloadPdf(false, false)">PDF Copy</button>
  <button class="btn btn-info btn-md" (click)="onDownloadPdf(true, false, true)">ZIP (document & attachments)</button>
  <button class="btn btn-info btn-md" (click)="onDownloadPdf(true, false, true, true)">ZIP (attachments only)</button>
  <button class="btn btn-info btn-md" (click)="onDownloadPdf(); onDownloadPdf(true, false, true, true)">PDF & ZIP</button>
</div>